import React from 'react'
import './Viewer.css'
import { useState } from "react";

import { Tooltip } from 'react-tippy';
import "react-tippy/dist/tippy.css";

import vergroot from './../images/up-right-and-down-left-from-center-solid.svg';
import verklein from './../images/down-left-and-up-right-to-center-solid.svg';

function Viewer(props) {

  const [fullscreenViewer, setFullscreenViewer] = useState(false);

  if( fullscreenViewer === true ) {
    document.body.classList.add('modal-open');
  } else {
    document.body.classList.remove('modal-open');
  }

  const handleToggle = () => {
    setFullscreenViewer(!fullscreenViewer)
  }

  return ( 
    <>
    <div className='iframe-placeholder'>
      
      <div className={fullscreenViewer ? 'iframe fullScreen' : 'iframe'}>
        <div className='iframe-inner'>
          <div className='iframe-header'>
            <div className="title">{props.title}&nbsp;</div>
            <div className='button' onClick={handleToggle}>
              <Tooltip title={`Klik om te ${fullscreenViewer ? "verkleinen" : "vergroten"}`} position="bottom" distance="0" followCursor="true" transitionFlip="false" animation="none" animateFill="false">
                <div className='actieKnop' >
                  <img src={fullscreenViewer ? verklein : vergroot} alt="" />                  
                </div>
              </Tooltip>
            </div>            
          </div>
          <iframe width="100%" height="600" title={props.title} src={props.src}></iframe>
          <div className="source">{props.source}</div>
        </div>
      </div>
      </div>
    </>
  )
}

export default Viewer